import React, { useState } from 'react';
import { firebase } from './firebase/index';
import { getSessionId, messages } from './helpers/custom';
import { validate, rulesPerPage } from './data/rules';
import { form, dynamicModifications, detailsPerPage, getKeysList } from './data/form';
import { FormPage } from './pages/FormPage';

import Swal from 'sweetalert2'
import './App.css';

const formURL = 'https://us-central1-mon-formulaire.cloudfunctions.net/submitForm';

const sessionID = getSessionId();

/*
let initialDocument = {
  "companyName": "DOC AUTO SARL",
  "bossSurname": "Anoufa",
  "bossName": "Mickael",
  "bossEmail": "mickaelanoufa@gmail.com",
  "phoneNumber": "0620080941",
  "amountDG": "1500000",
  "placeNumber": "4",
  "substitutionType": "DGandGAPD",
  "seniority": "moreThan2Year",
  "codeNAF": "123DD",
  "CA": "2000000",
  "estimatedCA": "2000000",
  "capital_social": "200000",
  "prime_emission": "200",
  "reserve_legal": "200000",
  "reserve_statutaire": "200",
  "reserve_reglemente": "200",
  "reserve_autre": "200",
  "report_nouveau": "200",
  "resultat_exercice": "658742",
  "file_liasse_fiscale": "liasse_fiscale__xhztfr3qi",
  "agentEmail": "mickaelanoufa@gmail.com",
  "tenantEmail": "mickaelanoufa@gmail.com",
  "lessorEmail": "mickaelanoufa@gmail.com",
  "companyAge": "moreThanTwoYears",
  "typeOfSubstitution": "DG",
  "companySIREN": "45683837",
  "managerName": "ANOUFA",
  "managerFirstName": "Mickael",
  "managerPhone": "0620080941",
  "revenueLastYear": "2000000",
  "revenueCurrentYear": "200000",
  "amountGAPD": "20000",
  "numberOfRooms": "3",
  "typeOdLease": "newLease",
  "threeYearTerm": "NON",
  "noticeOfLeave": "OUI",
  "refusalOfStateGuaranteedLoan": "NON",
  //"taxBundle1": "liasse_fiscale1_ILCM71678449",
  "GAPDisMoreThanSixMonth": "OUI",
  //"taxBundle2": "liasse_fiscale2_ILCM71678449"
};
*/

let initialDocument = {};

const keysList = getKeysList();

function convertKey(keysList, k) {
  if(keysList[k]) return keysList[k];
  return k;
}

function getReadableForm(formData) {
  let list = [];
  for(var key in formData) {
    list.push(`${convertKey(keysList, key)}: ${formData[key]}`);
  }
  return list;
}


if(window.location.pathname.includes('content')) {
  const content = window.location.pathname.slice(9);
  const fragment = JSON.parse(atob(content));
  initialDocument = Object.assign({}, initialDocument, fragment);
}

function App() {

 
  const recordDocument = async (doc) => {
    (async () => {
      
      const user = firebase.auth().currentUser;

      console.log(doc);
      
      if(!user?.uid) {
        console.log("Utilisateur non authentifié");
        return;
      }

      //if (!validate(rulesPerPage.flat(), doc, alertCallback)) return;

      //const timestamp = firebase.firestore.FieldValue.serverTimestamp(); 
      doc = { ...doc, _id : sessionID, userId: user.uid };
      doc.list = getReadableForm(doc);
      doc = { ...doc,   formSubject: "formulaire de contact Quietrent", subjectID: "contact_quietrent"};

      const body = JSON.stringify(doc);

      messages.showLoading();

      await fetch(formURL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body
      })
      .catch((error) => {
        console.error("Error: ", error);
        messages.showError();
        throw 'Record error';
      });

      //console.log(doc);

      //if(!documentRef) documentRef = db.collection("quietrent-eligibility-forms").doc();
      /*
      const documentResult = await documentRef
      .set(doc)
      .catch((error) => {
        console.error("Error: ", error);
        Swal.fire('Formulaire', 'Erreur serveur', 'error');
        throw 'Firebase error';
      });
      */
      //sendReportByEmail(doc);
      await messages.showValidated();
      window.location.href = 'https://www.quietrent.com';
      
    })().catch((error) => { console.log(error) });
  }

  const props = {
    form, 
    initialDocument,
    recordDocument, 
    sessionID,
    rulesPerPage,
    detailsPerPage,
    validate,
    dynamicModifications
  };

  return <FormPage {...props}></FormPage>
}

export default App;
